import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MetaInfo from 'vue-meta-info'

import '@/utils/globalDirective' // 指令

import './assets/js/gt'// 极验

import 'normalize.css/normalize.css'
// global css
import './assets/css/index.scss' // 根是scss文件，子scss文件才生效
import './assets/css/reset.css'

// 西瓜视频
import 'xgplayer/dist/index.min.css';

import './assets/js/echarts-wordcloud.min.js'

// 按需加载阿里播放器组件
// import RateComponent from './assets/js/rate.js'
// import QualityComponent from './assets/js/quality.js'

// if (!window.AliPlayerComponent) {
//   window.AliPlayerComponent = {}
// }

// Vue.prototype.$mathJs = mathJs

// window.AliPlayerComponent.RateComponent = RateComponent
// window.AliPlayerComponent.QualityComponent = QualityComponent

Vue.prototype.bus = new Vue()

Vue.use(MetaInfo)

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV === 'development' // 线上环境关闭开发调试

new Vue({
  el: '#app',
  router,
  // mounted() {
  //   document.dispatchEvent(new Event('render-event'))
  // },
  store,
  render: h => h(App)
})
